<div class="lm-delete-dialog">
  <div class="lm-dialog-header">
    <h2 class="lm-dialog-title">{{ data.title || 'Confirm Deletion' }}</h2>
    <button class="lm-dialog-close-btn" (click)="onCancel()" [attr.aria-label]="'leave_management.delete_dialog.aria_label.close' | transloco">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" fill="#D92D20"/>
        <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div class="lm-dialog-divider"></div>

  <div class="dd-body">
    <p class="dd-message">
      {{ data.message || 'Are you sure you want to delete' }}
      <strong class="dd-item-name">{{ data.itemName }}</strong>
      @if (!data.message) {?&nbsp;This action cannot be undone.}
    </p>
  </div>

  <div class="lm-dialog-footer--centered">
    <button class="lm-btn lm-btn--reset dd-cancel-btn" type="button" (click)="onCancel()">
      {{ data.cancelText || 'Cancel' }}
    </button>
    <button class="lm-btn lm-btn--danger-outline dd-delete-btn" type="button" (click)="onDelete()">
      {{ data.confirmText || 'Delete' }}
    </button>
  </div>
</div>